"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AccordionWrapper = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Accordion__AccordionWrapper",
  componentId: "b7cxw1-0"
})([".AccordionItem:first-of-type{border-top-left-radius:3px;border-top-right-radius:3px;}.AccordionItem:not(:last-of-type){border-bottom:0;}.AccordionItem:last-of-type{border-bottom-left-radius:3px;border-bottom-right-radius:3px;}"]);

// Accordion is implemented as a controlled component in which it only finds
// the child which has a value matching with our current value prop. Whenever a
// new child is selected, given `onChange` handler will be called with this
// value, so it's caller's responsibility to make sure it's given as a new
// value to this component again.
// Eg:
//
// const Example = () => {
//   const [selected, setSelected] = React.useState(null)
//
//   // onChange handler will always be called with the selected item's value
//   return (
//     <Accordion value={selected} onChange={selectedValue => setSelected(selectedValue)}>
//       <AccordionItem value="foo">Foo</AccordionItem>
//       <AccordionItem value="bar">Bar</AccordionItem>
//     </Accordion>
//   )
// }
const Accordion = ({ value, onChange, children }) => {
  // we are using this to track which child is selected
  // if we can find it we will be able to call `onChange` handler on it.
  let selectedChild = null;

  let newChildren = _react2.default.Children.map(children, child => {
    let isSelected = false;

    // if our `value` from our props is the same as this child's props.value
    // this means that this child is selected.
    if (child.props && child.props.value === value) {
      selectedChild = child;
      isSelected = true;
    }

    return _react2.default.cloneElement(child, {
      selected: isSelected,
      // we override the child's onChange handlers for 2 reasons:
      // 1) call our `onChange` from our props with the child's value.
      // 2) don't call child's `onChange` value, because we want to manage it
      // from this component
      onChange: () => {
        onChange(child.props.value);
      }
    });
  });

  // On initial render we call onChange handler with the selected child's value
  // if we can find it.
  (0, _react.useEffect)(() => {
    if (selectedChild) {
      onChange(selectedChild.props.value);
    }
  }, []);

  return _react2.default.createElement(
    AccordionWrapper,
    null,
    newChildren
  );
};

Accordion.propTypes = {
  children: _propTypes2.default.node,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = Accordion;